/**
 * UnifiedBetCard.jsx — thin shell (god-file decomposition).
 *
 * Logic lives in ../hooks/useUnifiedBetCard (state, effects, memo, handlers,
 * derived values). Rendering lives in ./UnifiedBetCardView. This file just
 * wires the two together so callers are unaffected.
 *
 * Styles: ./unifiedBetCardStyles. Math: ../utils/canonicalEv.
 * Display helpers: ../utils/betCardFormatters (shared with BetCardV2).
 */

import React, { useContext } from 'react';
import { useUnifiedBetCard } from '../hooks/useUnifiedBetCard';
import UnifiedBetCardView from './UnifiedBetCardView';
import { RelatedMarketsContext } from './RelatedMarkets';
import { cardDomId } from '../utils/relatedMarkets';

const NO_RELATED = [];

const UnifiedBetCard = (props) => {
    const merged = useUnifiedBetCard(props);
    // Related markets: the results list provides the index (components/RelatedMarkets).
    const related = useContext(RelatedMarketsContext);
    const cardKey = related ? related.keyOf(props.option) : null;
    return (
        <UnifiedBetCardView
            {...merged}
            cardDomId={cardKey ? cardDomId(cardKey) : undefined}
            relatedMarkets={cardKey && !props.isSGP ? related.relatedFor(cardKey) : NO_RELATED}
            onRelatedMarketPress={related ? related.goTo : undefined}
        />
    );
};

export default UnifiedBetCard;
